module.exports = __webpack_public_path__ + "img/sem_touca_mascara2.cd88095d.svg";